import { useBreakpointValue } from "@gluestack-ui/themed";
import { MenuActionItemProps } from "@repo/core/components/layout/MenuActionsList/components/MenuActionItem/types";
import { useNavigation } from "@repo/core/hooks/useNavigation";
import { ROUTES } from "@repo/core/routes";

export const EmergencyWithdrawOptionsController = () => {
  const { back, push } = useNavigation();
  const isMobile = useBreakpointValue({ base: true, md: false });
  const menuActionItems: MenuActionItemProps[] = [
    {
      title: "Á vista",
      onPress: () => push(ROUTES.emergencyWithdraw)
    },
    {
      title: "Parcelamento Sem Juros",
      onPress: () => push(ROUTES.emergencyWithdraw)
    },
    {
      title: "Parcelamento Com Juros",
      onPress: () => push(ROUTES.emergencyWithdraw)
    }
  ];
  return { back, isMobile, menuActionItems };
};
